import React from 'react';
import { connect } from 'react-redux';
import { Text } from '@beef/ui-kit';
import { NTabs } from '@fttb/common/components';
import PropTypes from 'prop-types';
import { setTariffsGroupAnalytics } from "../../../../store/blocks/tariffs/actions";
import { getTariffTabsList, getTariffsGroup } from "../../../../store/blocks/tariffs/selectors";
var _TariffsBlockTabs = function _TariffsBlockTabs(_ref) {
  var _tabs$;
  var className = _ref.className,
    onChange = _ref.onChange,
    selectedTab = _ref.selectedTab,
    tabs = _ref.tabs;
  return (tabs === null || tabs === void 0 ? void 0 : tabs.length) > 1 ? /*#__PURE__*/React.createElement(NTabs, {
    className: className,
    noWrap: true,
    onChange: onChange,
    selectedTab: selectedTab,
    tabs: tabs,
    variant: "secondary",
    "data-t-id": "components-TariffsBlockTabs"
  }) : /*#__PURE__*/React.createElement("div", {
    className: "mar-b-m"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "size2-m"
  }, tabs === null || tabs === void 0 || (_tabs$ = tabs[0]) === null || _tabs$ === void 0 ? void 0 : _tabs$.title));
};
_TariffsBlockTabs.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string,
  onChange: PropTypes.func,
  selectedTab: PropTypes.string,
  tabs: PropTypes.arrayOf(PropTypes.shape({}))
} : {};
var mapStateToProps = function mapStateToProps(state) {
  return {
    selectedTab: getTariffsGroup(state),
    tabs: getTariffTabsList(state)
  };
};
var mapDispatchToProps = {
  onChange: setTariffsGroupAnalytics
};
export var TariffsBlockTabs = connect(mapStateToProps, mapDispatchToProps)(_TariffsBlockTabs);